import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Center from "../common/components/Center";
import HorizontalSlider from "../common/components/HorizontalSlider";
import { actionsValues } from "../features/listenerProfile";
import VerticalCenter from "../common/components/VerticalCenter";
import Padding from "../common/components/Padding";

export default function Question3ActionsValues() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <>
      <Padding>
        <Center>
          <h1>{t("How often are your actions true to your values?")}</h1>
        </Center>
      </Padding>
      <VerticalCenter>
        <HorizontalSlider
          leftElement={<p>{t("All of the time")}</p>}
          values={[1, 2.33, 3.66, 5]}
          defaultValue={2.33}
          onChange={(value) => dispatch(actionsValues(value))}
          rightElement={<p>{t("None of the time")}</p>}
        />
      </VerticalCenter>
    </>
  );
}
